<template>
    <section class="assessmentSection questionsSection">
        <div class="pageContent">

            <!-- WHEN ROOM SELECTED -->
            <header class="sectionHeader">
                <div class="pageTitle">Tell us about the {{ areaOfConcern.name }}</div>
            </header>

            <AocView>
                <section class="addingSection aocEvaluationSection duplicateAreaSection">
                    <div class="duplicateAreaTitle">
                        <div class="icon"></div>
                        <div class="text">
                            Oops, looks like you’ve already added your {{ areaOfConcern.name }}. 
                        </div>
                    </div>
                    <p>
                        Are you sure you want to add another {{ areaOfConcern.name }}?
                    </p>
                    <div class="duplicateAreaActions">
                        <button class="button outline primary" @click="yes">Yes</button>
                        <button class="button outline primary" @click="no">No</button>
                    </div>
                    <!-- <div class="duplicateAreaEdit">
                        I'm trying to edit the {{ areaOfConcern.name }}
                    </div> -->
                </section>
            </AocView>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import AocView from '../../components/AocView.vue'
export default {
    components: {
        AocView
    },
    data: () => ({}),
    computed: {
        ...mapState(['areaOfConcern', 'emptyAreaOfConcern']),
    },
    methods: {
        ...mapActions([
            'updateAreaOfConcern', 
            'restrictToUnsignedInteger',
            'incrementAocSectionIndex',
            'decrementAocSectionIndex',
            'setAocSectionIndex'
        ]),

        no() {
            this.resetArea()
        },

        yes() {
            this.setAocSectionIndex(1)
        },

        next() {
            this.updateAreaOfConcern(this.areaOfConcern)
            this.incrementAocSectionIndex()
        },

        resetArea() {
            // Empty the local area of concern
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            this.setAocSectionIndex(-1)
        },

    }
}
</script>

<style lang="css"></style>

